<script>
import ResetModal from "@/components/modals/prestige/ResetModal";

export default {
  name: "BigCrunchModal",
  components: {
    ResetModal
  },
  data() {
    return {
      gainedInfinities: new Decimal(),
      gainedInfinityPoints: new Decimal(),
      startingBoosts: 0,
      startingAM: 10,
      willStartWithGalaxy: false
    };
  },
  computed: {
    isFirstInfinity() {
      return !PlayerProgress.infinityUnlocked();
    },
    message() {
      const info = this.isFirstInfinity ? this.firstInfinityInfo : ``;
      return `При Бесконечности, все Измерения, Бусты Измерений, и Галактики Антиматерий сбрасываются. ${info}`;
    },
    firstInfinityInfo() {
      return `Взамен, вы получаете Очко Бесконечности (ОБ). Это открывает вам возможность купить множество улучшений,
        которые вы можете найти во вкладке Бесконечность. Вы также получите одну Бесконечность, посмотреть количество
        которых вы можете во вкладке Статистики.`;
    },
    ipGainInfo() {
      return `Вы получите ${ruQuantify("Бесконечность,Бесконечности,Бесконечностей", this.gainedInfinities, 2, 0)}
        и ${ruQuantify("Очко Бесконечности,Очка Бесконечности,Очков Бесконечности", this.gainedInfinityPoints, 2, 0)}.`;
    },
    startingResources() {
      const gainedResources = [];
      if (this.startingAM.gte(10)) gainedResources.push(
        `${ruQuantify("Антиматерии,Антиматриями,Антиметерии", this.startingAM, 2, 1)}`);
      if (this.startingBoosts > 0) gainedResources.push(
        `${ruQuantify("Бустом Измерений,Бустами Измерений,Бустами Измерений", this.startingBoosts)}`);
      if (this.willStartWithGalaxy) gainedResources.push(
        `${ruQuantify("Галактикой,Галактиками,Галактиками", 1)}`);

      return `Вы начнёте вашу следующую Бесконечность с ${makeEnumeration(gainedResources)}.`;
    }
  },
  methods: {
    update() {
      this.gainedInfinities = gainedInfinities().round();
      this.gainedInfinityPoints = gainedInfinityPoints().round();
      this.startingBoosts = DimBoost.startingDimensionBoosts;
      this.startingAM = Currency.antimatter.startingValue;
      this.willStartWithGalaxy = InfinityUpgrade.skipResetGalaxy.isBought;
    },
    handleYesClick() {
      bigCrunchResetRequest();
      EventHub.ui.offAll(this);
      if (this.isFirstInfinity) {
        setTimeout(() => Modal.message.show(`Эта анимация будет срабатывать после каждой вручную полученной
          Бесконечности. Вы можете отключить её во вкладке Настроек. Это может быть сделано для каждой
          анимации в игре, после того как вы увидели её впервые.`, {}, 3), 2000);
      }
    }
  },
};
</script>

<template>
  <ResetModal
    header="Вы собираетесь начать новую Бесконечность"
    :message="message"
    :gained-resources="ipGainInfo"
    :starting-resources="startingResources"
    :confirm-fn="handleYesClick"
    :alternate-condition="isFirstInfinity"
    :alternate-text="message"
    :confirm-option="isFirstInfinity ? undefined : 'bigCrunch'"
  />
</template>
